import React from 'react'
import "./Welcome.css"
import text from './languages'

class WelcomeScreen extends React.Component {
  lang = this.props.langUI

  render() {
    return (
      <div className="welcome-container">
        <div className="welcome">
          <div className="game-title">
            {text.WS_TITLE[this.props.langUI]}
          </div>
          <div>
            {text.WS_DESCRIPTION[this.props.langUI]}
          </div>
          <div>
            {text.WS_TIMER_INPUT_1[this.props.langUI]} {this.renderSecondsInput()} {text.WS_TIMER_INPUT_2[this.props.langUI]}
          </div>
          <div>
            {text.WS_LIVES_INPUT_1[this.props.langUI]} {this.renderLivesInput()} {text.WS_LIVES_INPUT_2[this.props.langUI]}
          </div>
          <div>
          {text.WS_WORDS_LANG_INPUT[this.props.langUI]} {this.renderWordsLangInput()}
          </div>
          <div>
          {text.WS_BASEWORD_INPUT[this.props.langUI]}
          </div>
          {this.props.children}
          <div className="hints">
            <span className="hint"><i className="fas fa-mouse-pointer"></i> {text.WS_HINT_DEFINITION[this.props.langUI]}<br /></span>
            <span className="hint"><i className="fas fa-undo"></i> {text.WS_HINT_UNDO[this.props.langUI]}<br /></span>
            <span className="hint"><i className="far fa-pause-circle"></i> {text.WS_HINT_PAUSE[this.props.langUI]}</span>
          </div>
        </div>
      </div>
    )
  }

  renderSecondsInput = () => {
    return (
      <input 
        className="seconds-input" 
        type="number" 
        value={this.props.timer}
        onChange={(e) => {this.props.setTimerLength(e.target.value)}}
      />
    )
  }
  
  renderLivesInput = () => {
    return (
      <input 
        className="lives-input" 
        type="number" 
        value={this.props.lives}
        onChange={(e) => {this.props.setLivesAmount(e.target.value)}}
      />
    )
  }

  renderWordsLangInput = () => {
    return (
      <select 
        name="words-language" 
        id="words-language" 
        value={this.props.wordsLang} 
        onChange={(e) => this.props.setWordsLang(e.target.value)}
      >
        <option value="en">English</option>
        <option value="hi">Hindi</option>
        <option value="es">Spanish</option>
        <option value="fr">French</option>
        <option value="ja">Japanese</option>
        <option value="ru">Russian</option>
        <option value="de">German</option>
        <option value="it">Italian</option>
        <option value="ko">Korean</option>
        <option value="pt-BR">Brazilian Portuguese</option>
        <option value="ar">Arabic</option>
        <option value="tr">Turkish</option>
      </select>
    )
  }



}

export default WelcomeScreen